import { ChangeDetectionStrategy, Component, ElementRef, inject, output } from '@angular/core';
import { PageHeaderBackSwipeConfig, PageHeaderComponent } from '@app/components/page-header/page-header.component';
import { QrcodeComponent } from '@app/components/qrcode/qrcode.component';
import { BigScreenSchedule } from '@app/service/big-screen-schedule.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-more-schedule',
  templateUrl: './schedule.component.html',
  styleUrl: './schedule.component.scss',
  imports: [
    PageHeaderComponent,
    QrcodeComponent,
  ],
  host: {
    class: 'page',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScheduleComponent {

  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly bigScreenSchedule = inject(BigScreenSchedule);

  protected readonly backSwipeConfig: PageHeaderBackSwipeConfig = {
    element: this.elementRef.nativeElement,
  };

  public readonly schedule = toSignal(
    this.bigScreenSchedule.schedule$.pipe(
      map(events => events
        .filter(event => new Date(event.startTime) > new Date())
        .sort((a, b) => new Date(a.startTime).getTime() - new Date(b.startTime).getTime())
      )
    )
  );

  getEventDisplayDate(startTime: string): string {
    const eventDate = new Date(startTime);
    const now = new Date();

    const isToday =
      eventDate.getDate() === now.getDate() &&
      eventDate.getMonth() === now.getMonth() &&
      eventDate.getFullYear() === now.getFullYear();

    const tomorrow = new Date(now);
    tomorrow.setDate(now.getDate() + 1);

    const isTomorrow =
      eventDate.getDate() === tomorrow.getDate() &&
      eventDate.getMonth() === tomorrow.getMonth() &&
      eventDate.getFullYear() === tomorrow.getFullYear();

    if (isToday) {
      return `TONIGHT, ${eventDate.toLocaleString('en-US', { hour: 'numeric', hour12: true })}`;
    } else if (isTomorrow) {
      return `TOMORROW, ${eventDate.toLocaleString('en-US', { hour: 'numeric', hour12: true })}`;
    } else {
      return eventDate.toLocaleString('en-US', { weekday: 'long', hour: 'numeric', hour12: true });
    }
  }

  public readonly back = output();

}
